/* eslint-disable @typescript-eslint/no-explicit-any */
import request from '../../../request/request';
import { log } from '../../../utils/notification';

export const setLastVisitAPI = async (params) => {

  try{
    const response = await request<Request.LastVisit, any>(true, 'POST', 'services/messenger/set-last-visit',  { id: params.id });

    return response;
  } catch (error) {
    log('setLastVisitAPI', { response: error.message }, 'Error');
  }
};
